export enum BankQueryKeys {
	BankAccounts = 'bank-accounts',
	BankAccountById = 'bank-account-by-id',
	PaymentGateways = 'payment-gateways',
	PaymentGatewayById = 'payment-gateway-by-id',
	PaymentGatewayConstraints = 'payment-gateway-constraints',
	BankProviders = 'bank-providers',
	PaymentGateProviders = 'payment-gate-providers',
	SyncPaymentGateway = 'sync-payment-gateway',
	BankProviderNames = 'bank-provider-names',
	DepositTransactionById = 'deposit-transaction-by-id',
	OperatorDepositTransactions = 'operator-deposit-transactions',
	GetOperatorDepositTransactions = 'get-operator-deposit-transactions',
	OperatorWithdrawalTransactions = 'operator-withdrawal-transactions',
	Maintenances = 'maintenances',
	MaintenancesAll = 'maintenances-all',
	AvailableChannels = 'available-channels',
	ChannelCounts = 'channel-counts',
	PaymentGatewayAnalytics = 'payment-gateway-analytics',
}

export enum BankMutationKeys {
	CreateBankAccount = 'create-bank-account',
	UpdateBankAccount = 'update-bank-account',
	DeleteBankAccount = 'delete-bank-account',
	CreatePaymentGateway = 'create-payment-gateway',
	UpdatePaymentGateway = 'update-payment-gateway',
	DeletePaymentGateway = 'delete-payment-gateway',
	CreateBankDepositTransaction = 'create-bank-deposit-transaction',
	CreateBankWithdrawalTransaction = 'create-bank-withdrawal-transaction',
	CreateMaintenance = 'create-maintenance',
	RejectMaintenance = 'reject-maintenance',
	UploadOperatorDepositSlip = 'upload-operator-deposit-slip',
}
